module.exports = __webpack_public_path__ + "img/velodrome_logo.30338650.svg";